<template>
    <div class="sheet-row">
        <div class="sheet-row-line">
            <span class="sheet-row-label"><slot name="label">{{ label }}</slot></span>
            <div class="sheet-row-value"><slot /></div>
        </div>
        <div v-if="$scopedSlots.sub" class="sheet-row-sub"><slot name="sub" /></div>
    </div>
</template>

<script>
export default {
    name: 'FormRow',
    props: ['label'],
};
</script>

<style>
/* positioned, so a SheetSelect inside makes the whole row its tap area */
.sheet-row {
    position: relative;
    min-height: 44px;
    padding: 8px 12px;
    border-top: 1px solid var(--sheet-divider);
}
.sheet-group > .sheet-row:first-child {
    border-top: 0;
}
.sheet-row-line {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 28px;
}
.sheet-row-label {
    color: var(--sheet-field);
}
.sheet-row-value {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-left: auto;
    white-space: nowrap;
}
.sheet-row-sub {
    margin-top: 2px;
    text-align: right;
    font-size: 12px;
}
</style>
